import { ReactNode } from 'react'
import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps
} from '@mui/material'
import { isNumber } from 'lodash'
import { useTranslation } from 'react-i18next'

export interface NominalCurrentSelectProps extends Omit<
  SelectProps<number | null>,
  'children' | 'value'
> {
  value?: number | null
  onValueChange: (value: number) => void
}

export default function NominalCurrentSelect({
  value,
  onValueChange,
  onChange,
  ...props
}: NominalCurrentSelectProps) {
  const { t } = useTranslation('manufacturing')

  const handleChange = (event: SelectChangeEvent<number | null>, child: ReactNode) => {
    onChange?.(event, child)

    const nominalCurrent = event.target.value

    if (isNumber(nominalCurrent)) {
      onValueChange(nominalCurrent)
    }
  }

  return (
    <FormControl fullWidth>
      <InputLabel shrink={true}>{t('currentTransformers')}</InputLabel>
      <Select
        label={t('currentTransformers')}
        value={value !== undefined && value !== null ? value : ''}
        fullWidth
        {...props}
        onChange={handleChange}
      >
        <MenuItem value={100}>0 - 100 A (100 A)</MenuItem>
        <MenuItem value={250}>100 A - 1000 A (250 A)</MenuItem>
        <Divider />
        <MenuItem value={400}>400 A</MenuItem>
        <MenuItem value={600}>600 A</MenuItem>
      </Select>
    </FormControl>
  )
}
